//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: () => {
    return {
      open: false
    }
  },
  mounted() {
    console.log(this.$i18n.locale)
  },
  methods: {
    opendd() {
      this.open = !this.open
    },
    getFlag(locale) {
      return locale.code || 'en'
    }
  }
}
